import { useState } from "react";

export const useRoleForm = () => {
  const [form, setForm] = useState({
    name: "",
    role_code: "",
    description: ""
  });
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const resetForm = () => {
    setForm({ name: "", role_code: "", description: "" });
    setIsEdit(false);
    setEditId(null);
  };

  const setEditMode = (role) => {
    setForm({
      name: role.name,
      role_code: role.role_code,
      description: role.description
    });
    setIsEdit(true);
    setEditId(role.id);
  };

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    form,
    isEdit,
    editId,
    resetForm,
    setEditMode,
    updateField
  };
};
